import { cn } from '@/lib/utils'
import { ComponentProps, PropsWithChildren } from 'react'

export function Container({
  children,
  className,
  ...props
}: PropsWithChildren<ComponentProps<'div'>>) {
  return (
    <div
      className={cn('page-container', className)}
      {...props}
    >
      {children}
    </div>
  )
}
